import React, { useState } from 'react';
import { RiSearchLine, RiCloseLine } from 'react-icons/ri';
import { MdOutlineArrowOutward } from 'react-icons/md';

const SearchPopup = ({ isOpen, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchHistory, /*setSearchHistory*/] = useState([
    'Yoga mats',
    'Meditation cushions',
    'Rudraksha malas',
    'Incense sticks'
  ]);

  const popularTags = [
    'Yoga',
    'Meditation',
    'Ayurveda',
    'Puja items',
    'Rudraksha',
    'Incense',
    'Spiritual books',
    'Mala beads',
    'Idols',
    'Gemstones'
  ];

  if (!isOpen) return null;

  return (
    <div className="searchOverlay">
      <div className="searchPopup">
        <button className="closeBtn" onClick={onClose}>
          <RiCloseLine />
        </button>
        
        <div className="searchInputContainer">
          <input
            type="text"
            placeholder="Search for spiritual products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="searchInput"
          />
          <RiSearchLine className="searchIcon" />
        </div>

        <div className="tagsSection">
          <h3>Popular Spiritual Tags</h3>
          <div className="tagsContainer">
            {popularTags.map((tag, index) => (
              <span key={index} className="tag">
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="historySection">
          <h3>History</h3>
          <ul className="historyList">
            {searchHistory.map((item, index) => (
              <li key={index} className="historyItem">
                <span>{item}</span>
                <MdOutlineArrowOutward className="arrowIcon" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SearchPopup;